import { api } from "./api";
import { MunicipioResponse } from "../types/puesto";

export const MunicipioService = {
    //Obtener todos los municipios
    getAll: (activo: boolean) => {
        return api.get(`/municipios/${activo ? 1 : 0}`);
    },

    //Obtener todos los municipios con el usado
    getConUsado: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
            throw new Error("ID debe ser un número positivo");
        }
        return api.get(`/municipios/usado/${id}`);
    },

    //Obtener por id
    getById: (id: number) => {
        if (!Number.isInteger(id) || id < 0) {
            throw new Error("ID debe ser un número positivo");
        }
        return api.get(`municipios/${id}/individual`)
    },

    //Crear municipio
    create: (data: MunicipioResponse) => {
        return api.post("municipios", data);
    },

    //Actualizar municipio
    update: (id: number, data: MunicipioResponse) => {
        if (!Number.isInteger(id) || id < 0) {
            throw new Error("ID debe ser un número positivo");
        }
        return api.put(`municipios/${id}/actualizar`, data);
    },

    // Desactivar municipio
    desactivar: (id: number) => {
        return api.put(`/municipios/${id}/desactivar`);
    },

    // Activar municipio
    activar: (id: number) => {
        return api.put(`/municipios/${id}/activar`);
    },
}